import React from 'react';
import { Box, Container, Typography, Stack } from '@mui/material';
import { DeviceList } from '../components/devices';
import { ExportDpsButton } from '../components/devices/ExportDpsButton';

const DevicesPage: React.FC = () => {

  return (
    <Container maxWidth={false}>
      <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h4" component="h1">
          Device Management
        </Typography>
        <Stack direction="row" spacing={2}>
          <ExportDpsButton variant="outlined" />
        </Stack>
      </Box>
      <DeviceList />
    </Container>
  );
};

export default DevicesPage;
